/**
 * Formats message created time for display in user message bubbles.
 * Shows time only for today, or "Mon DD, HH:MM" / "Mon DD, YYYY, HH:MM" for older.
 */
export function formatMessageTime(createdTime: string | undefined): string | undefined {
  if (!createdTime) return undefined
  const date = new Date(createdTime)
  const now = new Date()
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timeStr = date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: tz
  })
  const isToday =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  if (isToday) return timeStr
  const isSameYear = date.getFullYear() === now.getFullYear()
  const dateStr = date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(isSameYear ? {} : { year: 'numeric' }),
    timeZone: tz
  })
  return `${dateStr}, ${timeStr}`
}
